import React, { useState, useContext, useRef } from "react";
import { PhotoManagerContext } from "..";
import { DeleteEventModalProps } from "../types";
import toastr from "../../../common/toastr";
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";

const alertIcon = require("../../../ManagePrepaidCustomers/components/images/alert.svg");

const DeleteEvent: React.FC<DeleteEventModalProps> = ({
  onClose,
  event,
  onDeleteEvent
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const context = useContext(PhotoManagerContext);

  usePopupClickOutside(popupRef, () => onClose());

  const handleDelete = () => {
    setLoading(true);
    try {
      if (event) onDeleteEvent(event);
    } catch (error) {
      console.error(`Error deleting event`, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--small"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content delete-folder-modal"
          ref={popupRef}
        >
          <div className="geo-modal__header geo-modal--warning-bg geo-del-header">
            <img
              className="delete-modal-warn-icon"
              src={alertIcon}
              alt="exclamation-warn"
            />
            <div className="delete-modal-header">Are you sure?</div>
          </div>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-content">
            <p className="delete-modal-info">
              All albums and photos in this event will be deleted. This cannot be undone.
            </p>

            <div className="modal-footer delete-folder-footer">
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps geo-btn--small delete-folder-btn"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-spinner">
                    Deleting..<span className="fa fa-spinner fa-spin"></span>
                  </div>
                ) : (
                  "I understand, continue"
                )}
              </button>
              <button
                className="geo-btn geo-btn--link geo-btn--caps delete-cancel-button"
                onClick={onClose}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default DeleteEvent;